module.exports = {
  name: 'jas',
  defaults: [
    {
      svg: {
        widthsAndHeights: 'path/to/svg oder SVG',
        length: 'path/to/svg oder SVG',
        notches: 'path/to/svg oder SVG'
      }
    },
    {
      profilColor: ''
    },
    {
      a: {
        min: 400,
        max: 99000,
        default: 400
      }
    },
    {
      a1: {
        min: 50,
        max: 300,
        steps: 10,
        default: 250
      }
    },
    {
      a2: {
        min: 50,
        max: 300,
        steps: 10,
        default: 250
      }
    },
    {
      totalLength: 500
    },
    {
      totalLengthOfOneElement: 3750
    },
    {
      b: {
        min: 140,
        max: 200,
        steps: 10,
        default: 160
      }
    },
    {
      h: {
        min: 35,
        max: 35,
        default: 35
      }
    },
    {
      w: {
        min: 0,
        max: 0,
        default: 0
      }
    },
    {
      e: {
        min: 105,
        max: 160,
        steps: 5,
        default: 125
      }
    },
    {
      d1: {
        min: 100,
        max: 480,
        steps: 5,
        default: 280
      }
    },
    {
      d2: {
        min: 80,
        max: 300,
        steps: 5,
        default: 200
      }
    },
    {
      c: {
        min: 160,
        max: 700,
        steps: 5,
        default: 500
      }
    },
    {
      dripEdgeProfile: 0
    },
    {
      wallProfiles: ''
    },
    {
      vacuumPanels: ''
    }
  ],

  /*
  * getters
  */

  get: function (value) {
    for (var i = 0; i < this.defaults.length; i++) {
      var obj = this.defaults[i]
      for (var key in obj) {
        if (key === value) {
          return obj[key]
        }
      }
    }
  },

  /*
  * set depedencies for values
  */

  // if Vakuumpanel is added Change value of W
  hasVIP: function () {
    const w = {
      min: 0,
      max: 0
    }
    return w
  },

  validateData: function (currentOrder) {
  },
  getErrors: function (currentOrder) {
    let errors = {}
    for (var i = 0; i < this.defaults.length; i++) {
      var obj = this.defaults[i]
      for (var key in obj) {
        var keyData = obj[key]
        var valueOfOrder = currentOrder[key]
        if (this.checkMin(keyData, valueOfOrder)) {
          errors[key] = ('min')
        }
        if (this.checkMax(keyData, valueOfOrder)) {
          errors[key] = ('max')
        }
        if (this.checkSteps(key, keyData, valueOfOrder)) {
          errors[key] = ('steps')
        }
        if (key === 'c' || key === 'd1') {
          if (currentOrder.c <= currentOrder.d1) {
            errors[key] = ('d1BiggerThenC')
          }
        }
        if (key === 'b') {
          if (currentOrder.e + currentOrder.h !== currentOrder.b) {
            errors[key] = ('bIsNotCorrect')
          }
        }
      }
    }
    return errors
  },

  getMins: function (currentOrder) {
    let minArray = []
    for (var i = 0; i < this.defaults.length; i++) {
      var obj = this.defaults[i]
      for (var key in obj) {
        // console.log(obj[key])
        minArray[key] = obj[key].min
      }
    }
    // console.log('minArray')
    // console.log(minArray)
    return minArray
  },

  checkMin: function (keyData, valueOfOrder) {
    let minError = false
    if (keyData.min) {
      if (keyData.min > valueOfOrder) {
        minError = true
      }
    }
    return minError
  },

  checkMax: function (keyData, valueOfOrder) {
    let maxError = false
    if (keyData.max) {
      if (keyData.max < valueOfOrder) {
        maxError = true
      }
    }
    return maxError
  },

  checkSteps: function (key, keyData, valueOfOrder) {
    let stepsError = false
    if (keyData.steps) {
      if (valueOfOrder % keyData.steps) {
        stepsError = true
      }
    }
    return stepsError
  },

  getWarnings: function (currentOrder) {
    // console.log('jakp getWarnings')
    let currentWarnings = {}

    // elementLengths related warnings
    let elementLengths = {}
    elementLengths['totalLengthOfOneElement'] = (currentOrder.totalElements > 1)
    elementLengths['totalElements'] = (currentOrder.totalElements > 1)
    currentWarnings['elementLengths'] = elementLengths

    // elementHeights related warnings
    let elementHeights = {}
    currentWarnings['elementHeights'] = elementHeights

    // elementWidths related warnings
    let elementWidths = {}
    elementWidths['eIsLowerThanEquals115'] = (currentOrder.e <= 115)
    elementWidths['elementWidthcalculationWarning'] = (currentOrder.e + currentOrder.h !== currentOrder.b)
    currentWarnings['elementWidths'] = elementWidths

    // vacuumPanels related warnings
    let vacuumPanels = {}
    currentWarnings['vacuumPanels'] = vacuumPanels

    // endProfiles related warnings
    let endProfiles = {}
    currentWarnings['endProfiles'] = endProfiles

    return currentWarnings
  },

  // Helper functions

  log: function () {
    // console.log(this)
  }
}
